import { setRentAgreements, setInvoiceInfo } from "../features/rentSlice";
import apiAction from "../ajax/service";

const loadAgreements = async (
  dispatch,
  page = 2,
  limit = 25,
  pageData = {},
  rentId ,
  filters={}
) => {

  if (pageData instanceof Set) {
    if (pageData.has(page)) return;
  } else {
    if (page in pageData) return;
  }
  var data = await apiAction(
    "agreements",
    { page, limit, filters: { rentalId: rentId , ...filters } },
    "getRentalAgreements",
    dispatch
  );

  dispatch(
    setRentAgreements({ page, data:data.data?  data.data : data , total:data.total}),
  );
  // for (let agreement of data.data) {

  //   dispatch(
  //     setInvoiceInfo({
  //       agreementId: agreement.id,
  //       data: agreement["invoices"],
  //       page: 1,
  //       total: agreement._count.invoices,
  //     }),
  //   );
  // }
};
const updateAgreement = async(record)=>{
  const updated = await apiAction("forms",{modal:"RentalAgreement",...record,id:record.id , rawFieldUpdate:true},"update")
}
const deleteAgreement = async(record) =>{
 const deleted = await apiAction("forms",{modal:"RentalAgreement",...record,id:record.agreementId},"delete")
}
const deleteAgreementItem = async(record) =>{
 const deleted = await apiAction("forms",{modal:"AgreementItem",...record},"delete")
}
export { loadAgreements  , deleteAgreement, deleteAgreementItem , updateAgreement};
